import { trackAnalyticsAddToCart } from "../utils/webAnalyticsEvents";

function cartLineKey(item) {
  if (!item) return "";
  return item.sizeVariant ? `${item._id}_${item.sizeVariant.value}` : String(item._id);
}

/**
 * GA4/Clarity add_to_cart on first cart line add only (not quantity bumps).
 */
export const webAnalyticsCartMiddleware = (storeApi) => (next) => (action) => {
  if (action.type !== "cart/addProduct") {
    return next(action);
  }

  const p = action.payload || {};
  if (!p.productID) {
    return next(action);
  }

  const cartKey = p.sizeVariant ? `${p._id}_${p.sizeVariant.value}` : p._id;
  const existing = storeApi.getState().cart.products.find((product) => {
    const productCartKey = cartLineKey(product);
    return productCartKey === cartKey;
  });

  const isFirstAdd = !existing;
  const result = next(action);

  if (isFirstAdd) {
    const qty = Number(p.qty) || 1;
    const unit = Number(p.unitPrice) || 0;
    const currency = storeApi.getState()?.store?.storeData?.currency || "INR";
    trackAnalyticsAddToCart({
      productID: p.productID,
      productName: p.productName,
      unitPrice: unit,
      qty,
      currency,
    });
  }

  return result;
};
